export const AuthEditorialPanel = () => (
  <div className="hidden lg:flex flex-col justify-between p-12 xl:p-16 border-r border-[#E7DFD5] relative overflow-hidden">
    <div className="section-tag">§ Members Only</div>
    <div>
      <h1 className="font-display text-6xl xl:text-7xl leading-[0.9] tracking-tight mb-6">
        Heal before <span className="italic text-[#B45309]">the shift</span>.
      </h1>
      <p className="text-[#78716C] text-lg leading-relaxed max-w-md">
        Access your modules, track your practice, and join the community forged through adversity.
      </p>
    </div>
    <div className="font-display text-[9vw] leading-none text-[#44403C]">T.A.C.C.<span className="text-[#B45309]">.</span></div>
  </div>
);
